const React = require('react');

const { createContext, useState } = React;

const ContextProvider = (props) => {
  const [commonValueThumb, setCommonValueThumb] = useState();

  return (
    <div>
      <GuidesContext.Provider value={[commonValueThumb, setCommonValueThumb]}>
        {props.children}
      </GuidesContext.Provider>
    </div>
  );
};
const GuidesContext = createContext();

module.exports = ContextProvider;
module.exports.GuidesContext = GuidesContext;
